import React, { useState, useEffect, FC } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import UserManagement from './user-management/UserManagement';
import OrganisationManagement from './organisation-management/OrganisationManagement';
import UserPreferenceService from '../services/UserPreferenceService';
import TopicManagement from './configure-topics/TopicManagement';
import useAuthorization from '../hooks/useAuthorisationManager';
import { ROLES } from '../constants';

const userPreferenceService = new UserPreferenceService();

const GeneralManagement: FC = () => {
  const [tab, setTab] = useState<number>(0);
  const { hasRole } = useAuthorization();
  const isSuperUser = hasRole(ROLES.SuperUser);

  useEffect(() => {
    const savedTab = userPreferenceService.get('GeneralManagementTab');
    if (savedTab !== null) {
      setTab(parseInt(savedTab, 10));
    }
  }, []);

  useEffect(() => {
    userPreferenceService.save('GeneralManagementTab', tab.toString());
  }, [tab]);

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  return (
    <div className="page-container">
      <h1 className="page-header">Users &amp; Organisations</h1>
      <Tabs
        value={tab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        style={{ marginBottom: 24 }}
      >
        <Tab label="Users" style={{ textTransform: 'none', fontWeight: 600, fontSize: 14 }} />
        <Tab label="Organisations" style={{ textTransform: 'none', fontWeight: 600, fontSize: 14 }} />
        {isSuperUser && <Tab label="Topics" style={{ textTransform: 'none', fontWeight: 600, fontSize: 14 }} />}
      </Tabs>
      {tab === 0 && <UserManagement />}
      {tab === 1 && <OrganisationManagement />}
      {tab === 2 && isSuperUser && <TopicManagement />}
    </div>
  );
};

export default GeneralManagement;
